export const searchFormOption = function () {
    return [
        {
            prop: 'val1',
            label: '输入',
            type: 'input',
            placeholder: '请输入内容'
        },
        {
            prop: 'val2',
            label: '下拉',
            type: 'select',
            placeholder: '请选择内容',
            options: this.selectOption
        },
        {
            prop: 'val4',
            label: '时间',
            type: 'range-picker',
        },
        {
            prop: 'val6',
            label: '日期',
            type: 'range-date',
        },
        {
            prop: 'val5',
            label: '级联',
            type: 'cascader',
            placeholder: '请选择内容',
            propConfig: {
                value: 'id',
                label: 'name'
            },
            options: this.cascaderOption
        }
    ]
}

export default {}